module.exports = __webpack_public_path__ + "img/Easypaper.796f709d.png";